export default "__VITE_ASSET__CB901vCu__"